// extracted by mini-css-extract-plugin
export default {"selectPopover":"select_selectPopover__xQZmB"};